import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { CatalogService } from '../../services/catalog.service';
import { CatalogActions } from './catalog.actions';

@Injectable()
export class CatalogEffects {
  private actions$ = inject(Actions);
  private catalogService = inject(CatalogService);

  loadCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadCatalog),
      switchMap(() =>
        this.catalogService.getCatalog().pipe(
          map((products) => CatalogActions.loadCatalogSuccess({ products })),
          catchError((error) => of(CatalogActions.loadCatalogFailure({ error: error.message })))
        )
      )
    )
  );

  loadProductDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadProductDetails),
      switchMap(() =>
        this.catalogService.getProductDetails().pipe(
          map((productDetails) => CatalogActions.loadProductDetailsSuccess({ productDetails })),
          catchError((error) => of(CatalogActions.loadProductDetailsFailure({ error: error.message })))
        )
      )
    )
  );

  loadProductDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadProductDetail),
      switchMap(({ code }) =>
        this.catalogService.getProductDetail(code).pipe(
          map((productDetail) => CatalogActions.loadProductDetailSuccess({ code, productDetail })),
          catchError((error) =>
            of(CatalogActions.loadProductDetailFailure({ code, error: error.message }))
          )
        )
      )
    )
  );

  loadTagMapping$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadTagMapping),
      switchMap(() =>
        this.catalogService.getTagMapping().pipe(
          map((tagMapping) => CatalogActions.loadTagMappingSuccess({ tagMapping })),
          catchError((error) => of(CatalogActions.loadTagMappingFailure({ error: error.message })))
        )
      )
    )
  );
}
